import { getReports, getResults, deleteResult } from "./report";

const reportService = {
  getResults,
  getReports,
  deleteResult,
};

export { reportService };
